import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { keyframes, css, jsx } from '@emotion/react';
import { Colors, Zindexes, Animation } from '@zapier/design-system';
import React from 'react';
import { ModalOverlay, Modal, Dialog } from 'react-aria-components';
import { IconButton } from '../IconButton/IconButton.es.js';
import { BREAKPOINTS } from '../constants.es.js';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;
const OPACITY_80_PERCENT = "CC";
const ModalOverlayStyles = css({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: `var(--zds-background-overlay, ${Colors.neutral800}${OPACITY_80_PERCENT})`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: Zindexes.modalOverlay,
  "&[data-entering]": {
    animation: `${fadeIn} ${Animation.transitionDuration}`
  },
  "&[data-exiting]": {
    animation: `${fadeOut} ${Animation.transitionDuration} ${Animation.transitionTimingFunction}`
  }
});
const ModalStyles = css({
  position: "relative",
  borderRadius: "5px",
  maxWidth: "calc(100vw - var(--zds-space-20, 20px))",
  maxHeight: "min(650px, calc(100vh - 70px))",
  backgroundColor: `var(--zds-background-weaker, ${Colors.neutral100})`,
  outline: "none",
  boxShadow: "-8px 0 20px rgba(0 0 0 / 0.1)",
  [`@media screen and (min-width: ${BREAKPOINTS.tablet})`]: {
    minWidth: "550px",
    maxWidth: "650px",
    margin: "0px var(--zds-space-20, 20px)"
  }
});
const DialogStyles = css({
  display: "flex",
  flexDirection: "column",
  maxHeight: "inherit",
  padding: "var(--zds-size-20, 20px)",
  [`@media screen and (min-width: ${BREAKPOINTS.tablet})`]: {
    padding: "var(--zds-size-36, 40px)"
  }
});
const CloseButtonStyles = css({
  position: "absolute",
  top: "8px",
  right: "8px",
  zIndex: Zindexes.closeButton
});
const ModalContent = (_a) => {
  var { children, className, isDismissable = true } = _a, props = __rest(_a, ["children", "className", "isDismissable"]);
  return jsx(
    ModalOverlay,
    { css: ModalOverlayStyles, "data-zds": true, isDismissable },
    jsx(
      Modal,
      { css: ModalStyles, "data-zds": true, className, isDismissable },
      jsx(Dialog, Object.assign({}, props, { css: DialogStyles, "data-zds": true }), ({ close }) => jsx(
        React.Fragment,
        null,
        isDismissable && jsx(IconButton, { css: CloseButtonStyles, name: "formX", onPress: close, variant: "ghost" }),
        children
      ))
    )
  );
};

export { ModalContent };
//# sourceMappingURL=Content.es.js.map
